<tec-tile
	[title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.ADVANCED_CONFIG' | translate"
	icon="icon-settings"
>
	<div class="form-step-config">
		<tec-item
			[title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.REQUIRED' | translate"
			[classes]="['item--outline']"
			[clickeable]="false"
		>
			<tec-list-detail>
				<span>{{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.REQUIRED_DESCRIPTION' | translate }}</span>
			</tec-list-detail>

			<tec-switch
				[value]="required"
				size="sm"
				[disabled]="requiredLocked"
				(valueChange)="requiredChange.emit($event)"
			></tec-switch>
		</tec-item>

		<tec-divider></tec-divider>

		@if (showMatchOcr) {
			<tec-item
				[title]="'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.MATCH_OCR_SHORT' | translate"
				[classes]="['item--outline']"
				[clickeable]="false"
			>
				<tec-list-detail>
					<span>{{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.MATCH_OCR_DESCRIPTION' | translate }}</span>
				</tec-list-detail>

				<tec-switch
					[value]="matchOcrEnabled"
					size="sm"
					[disabled]="matchOcrLocked"
					(valueChange)="matchOcrChange.emit($event)"
				></tec-switch>
			</tec-item>

			<tec-divider></tec-divider>
		}
	</div>
</tec-tile>
